import {updateRepairRequestQuery} from '../models/repair.model';
import {constructUrl, HttpClient} from '../helper/HttpClient';

export type updateReplacementDateQuery = {
	sysId: string,
	date: Date
}


export async function updateReplacementDate(query: updateReplacementDateQuery): Promise<string> {
    const url = constructUrl('laptopReplacement');
    const httpClient = new HttpClient();
    return await httpClient.post<string>(url, JSON.stringify(query));
}